import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { ToasterModule, ToasterService } from 'angular2-toaster';

import { Router } from "@angular/router";
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Cookie } from 'ng2-cookies';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/catch';
import { ExcelService } from './excel/excel.service';
import { CustomResponse } from '../models/response';
import { catchError, debounceTime,distinctUntilChanged } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { RuntimeConfigService } from './runtime-config.service';
import { applyUiModeToRedirectPath } from '../utils/ui-mode';


declare var jsPDF: any;

@Injectable()
export class WebServiceService {
  tokenFromUI:string = "TYASuite!#!TYASuite!TYASuite!#!@";

  private invScanningSubject = new BehaviorSubject<Number>(0); // Initial value is an empty string
  public invScanningData$ = this.invScanningSubject.asObservable();
  private readonly ENABLE_CRASH_REPORT = false;

  constructor(
    private http: Http,
    private router: Router,
    public _localStorageService: LocalStorageService,
    private toasterService: ToasterService,
    private excelService: ExcelService,
    private runtimeConfigService: RuntimeConfigService,
  ) {
    this.getDynamicUrl();
    this.getImageUrl();
  }

  setScanningAnimation(value: Number) {
    this.invScanningSubject.next(value);
  }

  public getJsonByURL(url: string) {
    return this.http.get(url).map(res => res.json());
  }

  login_image_url:any='';
  urlEndPoint: any = '';
  aurlEndPoint: any = "https://" + window.location.host;
  chatbotUrl: any = "https://ai.tyasuite.in";

  //bucketUrl: any = "https://production.intelaccounts.in/prapp/";
  bucketUrl: any = "https://mt.intelaccounts.in/prapp/";
  //bucketUrl:any = "https://staging.tyasuite.com/prapp/index.php/"
  // method post
  addressUrl: any = "http://ipinfo.io";
  public online: boolean = navigator.onLine;
  imageUrl = "https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/";
  getImageUrl() {

    return this.imageUrl = "https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/";

  }
  formatDateAccordingToSetup(date, format) {
    if (date == undefined || date == null || ["", "NaN-NaN-", "-NaN-NaN", "NaN-NaN-NaN", "0000-00-00"].includes(date)) {
      return "";
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    switch (format) {
      case 'dd-mm-yyyy':
        return `${day}-${month}-${year}`;
      case 'yyyy-mm-dd':
        return `${year}-${month}-${day}`;
      case 'mm-dd-yyyy':
        return `${month}-${day}-${year}`;
      default:
        return date
    }
  }

  retrnUrl() {
    // this.getDynamicUrl();
    return this.urlEndPoint;
  }
  retrnBucketUrl() {
    return this.bucketUrl;
  }
  retrnAngularUrl() {
    //  return "https://" + window.location.origin;
    return window.location.origin;
  }
  isOnline() {
    if (this.online) {
      return true;
    }
    else {

      return false;
    }
  }

  getAccessToken() {
    //return Cookie.get("access_token");
    return this.get('access_token',localStorage.getItem('access_token'))

  }
  getUserAccessToken() {
    //return Cookie.get("access_token");
    return this.get('user_access_token',localStorage.getItem('user_access_token'))

  }

  commonPostErrorRepoter(url, payload) {
    if(!this.ENABLE_CRASH_REPORT) {
      return;
    }
    console.log(url)
    console.log(payload)
    this.commonPostMethod(url, payload).
      subscribe(
        data => {
        },
        error => {
        }
      );
  }
isAdminUrl(url)
{
  let urlList:any=[
    {'url':'/login/ajax_login'},
    {'url':'/Login_Exe/ajax_reset_password'},
    {'url':'User_activity/save_user_activity'},
    {'url':'Companies/view_client_setup'},
    {'url':'Login_Exe/ajax_forget_pwd'},
    {'url':'employees/ajax_getsingemp'},
    {'url':'Login_Exe/ajax_forget_pwd'},
    {'url':'/Vendor_management/loginVendor'},
    {'url':'employees/ajax_getsingemp_companies_details'}

  ];
  return urlList.some((v)=>{return v.url==url});
}

fullPostMethod(endPoint, data) {
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('authorization', this.getAccessToken())
  if(this.getUserAccessToken()!='')
  {
    headers.append('user_token', this.getUserAccessToken())
  }

  let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  let body = data;
  let flag = false;
  if(flag && Intl.DateTimeFormat().resolvedOptions().timeZone!="Asia/Calcutta" && Intl.DateTimeFormat().resolvedOptions().timeZone!="Asia/Kolkata")
  {
    if(Array.isArray(body))
    {
      for(let pk of body)
      {
        pk.time_zone=Intl.DateTimeFormat().resolvedOptions().timeZone?Intl.DateTimeFormat().resolvedOptions().timeZone:'';

        if(pk)
        {
          for (var k in pk)
          {
            if(Array.isArray(pk[k]))
            {
              if(pk[k])
              {
              for (var m of pk[k])
          {
            for(var l in m)
            {
            if(l.lastIndexOf('date')>=0||l.lastIndexOf('required_by')>=0)
            {
              // console.log(l);
              let key=l;
              let key_value=(m[l]!='' && m[l]!=undefined && m[l]!=null)?new Date(m[l]):m[l];
              // console.log('key='+key+" key value="+key_value);
              let part:any=[];
              // part= key_value.split("-");
              if((m[l]!='' && m[l]!=undefined && m[l]!=null))
              {
              m[l]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():m[l];
              }
              // console.log(m[l]);
            }
            }
          }
            }
          }
            else
      {
      if(k.lastIndexOf('date')>=0)
            {
              console.log(k);
              let key=k;
              let key_value=(pk[k]!='' && pk[k]!=undefined && pk[k]!=null)?new Date(pk[k]):pk[k];
              // console.log('key='+key+" key value="+key_value);
              // let part:any=[];
              // part= key_value.split("-");
              if((pk[k]!='' && pk[k]!=undefined && pk[k]!=null))
              {
              pk[k]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():pk[k]
              }
              // console.log(body[k]);
            }
      }

          }
        }
      }
    }
    else
    {
      if(body)
      {
        for (var k in body)
        {
          if(Array.isArray(body[k]))
          {
            if(body[k])
            {
            for (var m of body[k])
        {
          for(var l in m)
          {
          if(l.lastIndexOf('date')>=0||l.lastIndexOf('required_by')>=0)
          {
            // console.log(l);
            let key=l;
            let key_value=(m[l]!='' && m[l]!=undefined && m[l]!=null)?new Date(m[l]):m[l];
            // console.log('key='+key+" key value="+key_value);
            let part:any=[];
            // part= key_value.split("-");
            if((m[l]!='' && m[l]!=undefined && m[l]!=null))
            {
            m[l]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():m[l];
            }
            // console.log(m[l]);
          }
          }
        }
          }
        }
          else
    {
    if(k.lastIndexOf('date')>=0)
          {
            console.log(k);
            let key=k;
            let key_value=(body[k]!='' && body[k]!=undefined && body[k]!=null)?new Date(body[k]):body[k];
            // console.log('key='+key+" key value="+key_value);
            // let part:any=[];
            // part= key_value.split("-");
            if((body[k]!='' && body[k]!=undefined && body[k]!=null))
            {
            body[k]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():body[k]
            }
            // console.log(body[k]);
          }
    }

        }
      }
    }
  }

  body.time_zone=Intl.DateTimeFormat().resolvedOptions().timeZone?Intl.DateTimeFormat().resolvedOptions().timeZone:'';

  body.is_remove_keys=  body.is_remove_keys?body.is_remove_keys:'0'
  body.keys_list=body.keys_list?body.keys_list:[]
  
  if(body.is_remove_keys=='1')
  {
    if(body.keys_list)
    {
      for(let i of body.keys_list)
      {
        delete body[i];
      }
    }
  }

  if (body.company_id == '' || body.company_id == undefined || body.company_id == null) {
    body.company_id = this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '0';
  }

  if (body.user_id == '' || body.user_id == undefined || body.user_id == null) {
    body.user_id = this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0';
  }
  
  let today:Date=new Date();
  body.request_start_time=today.getHours()+":"+today.getMinutes()+":"+today.getSeconds()+":"+today.getMilliseconds()
  
  return this.http.post(endPoint, body, { headers: headers })
    // .pipe(debounceTime(dbTime),distinctUntilChanged())
    .map((response: Response) =>  response.json() as CustomResponse) // Calling json() as CustomResponse on the response to return data in JSON format of type CustomResponse
    // .catch((error: any) => Observable.throw(error || 'Server Error'));
    .catch(
      (error: Response) => {        
        return Observable.throw(error);
      }
    );
}

  commonPostMethod(url, data) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    if(data.public_reg && data.public_reg == '1') {
      data.venRegComToken = data.venRegComToken ? data.venRegComToken : "";
      headers.append('authorization', data.venRegComToken)
      delete data.venRegComToken;
    } else {
      headers.append('authorization', this.getAccessToken())
    }
    if(this.getUserAccessToken()!='')
    {
    headers.append('user_token', this.getUserAccessToken())
    }
      // append to call live server from local
    // headers.append('mode',"no-cors")


    // headers.append('Access-Control-Allow-Origin','*');


    let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let local_storage_company_id = this._localStorageService.getEmpCompanyId();
    let session_storage_company_id = sessionStorage.getItem('company_id');
    let is_vendor = this.get('ven_role',localStorage.getItem('ven_role')) == 'vendor' ? "1" : '0';
    // if session_storage_company_id is not integer or not '' or not null or not undefined then set it to local_storage_company_id
    if(session_storage_company_id && session_storage_company_id != 'undefined' && session_storage_company_id != '0' && !isNaN(Number(session_storage_company_id)) && is_vendor == '1'){
      session_storage_company_id = local_storage_company_id;
    }
    if(session_storage_company_id && session_storage_company_id != 'undefined' && session_storage_company_id != '0' && !isNaN(Number(session_storage_company_id))){
      if(session_storage_company_id != local_storage_company_id) {
        if(this.get('emp_role',localStorage.getItem('emp_role')) != 'administrator' && session_storage_company_id != '0' && local_storage_company_id != '0') {
          this.toasterService.pop('error', 'Error', 'Company session mismatch. Please reload the page once.');
          sessionStorage.setItem('company_id', local_storage_company_id);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          return;
        }
      }
    } else {
      sessionStorage.setItem('company_id', local_storage_company_id);
    }
    let body = data;
    let flag = false;
    if(flag && Intl.DateTimeFormat().resolvedOptions().timeZone!="Asia/Calcutta" && Intl.DateTimeFormat().resolvedOptions().timeZone!="Asia/Kolkata"
    && Intl.DateTimeFormat().resolvedOptions().timeZone!="Europe/London")
        {
         if(Array.isArray(body))
         {
           for(let pk of body)
           {
            pk.time_zone=Intl.DateTimeFormat().resolvedOptions().timeZone?Intl.DateTimeFormat().resolvedOptions().timeZone:'';

    if(pk)
    {
      for (var k in pk)
      {
        if(Array.isArray(pk[k]))
        {
          if(pk[k])
          {
          for (var m of pk[k])
      {
        for(var l in m)
        {
        if(l.lastIndexOf('date')>=0||l.lastIndexOf('required_by')>=0)
        {
          // // console.log(l);
          // let key=l;
          // let key_value=(m[l]!='' && m[l]!=undefined && m[l]!=null)?new Date(m[l]):m[l];
          // // console.log('key='+key+" key value="+key_value);
          // let part:any=[];
          // // part= key_value.split("-");
          // if((m[l]!='' && m[l]!=undefined && m[l]!=null))
          // {
          // m[l]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():m[l];
          // }
          // // console.log(m[l]);
         }
        }
      }
        }
      }
        else
{
  if(k.lastIndexOf('date')>=0)
        {
          // console.log(k);
          // let key=k;
          // let key_value=(pk[k]!='' && pk[k]!=undefined && pk[k]!=null)?new Date(pk[k]):pk[k];
          // // console.log('key='+key+" key value="+key_value);
          // // let part:any=[];
          // // part= key_value.split("-");
          // if((pk[k]!='' && pk[k]!=undefined && pk[k]!=null))
          // {
          // pk[k]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():pk[k]
          // }
          // // console.log(body[k]);
         }
}

      }
    }
    }
  }
  else
  {
    if(body)
    {
      for (var k in body)
      {
        if(Array.isArray(body[k]))
        {
          if(body[k])
          {
          for (var m of body[k])
      {
        for(var l in m)
        {
        if(l.lastIndexOf('date')>=0||l.lastIndexOf('required_by')>=0)
        {
          // console.log(l);
          // let key=l;
          // let key_value=(m[l]!='' && m[l]!=undefined && m[l]!=null)?new Date(m[l]):m[l];
          // console.log('key='+key+" key value="+key_value);
          // let part:any=[];
          // part= key_value.split("-");
          // if((m[l]!='' && m[l]!=undefined && m[l]!=null))
          // {sks
          // m[l]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():m[l];
          // }
          // console.log(m[l]);
         }
        }
      }
        }
      }
        else
{
  if(k.lastIndexOf('date')>=0)
        {
          // console.log(k);
          // let key=k;
          // let key_value=(body[k]!='' && body[k]!=undefined && body[k]!=null)?new Date(body[k]):body[k];
          // console.log('key='+key+" key value="+key_value);
          // let part:any=[];
          // part= key_value.split("-");
          // if((body[k]!='' && body[k]!=undefined && body[k]!=null))
          // {
          // body[k]=(typeof key_value.getMonth==="function")?key_value.getFullYear()+"-"+(key_value.getMonth()+1)+"-"+key_value.getDate():body[k]
          // }
          // console.log(body[k]);
         }
}

      }
    }
  }
  }
  body.time_zone=Intl.DateTimeFormat().resolvedOptions().timeZone?Intl.DateTimeFormat().resolvedOptions().timeZone:'';

  body.is_remove_keys=  body.is_remove_keys?body.is_remove_keys:'0'
    body.keys_list=body.keys_list?body.keys_list:[]
    if(body.is_remove_keys=='1')
    {
      if(body.keys_list)
      {
        for(let i of body.keys_list)
        {
          delete body[i];
        }
      }
    }



    if (body.company_id == '' || body.company_id == undefined || body.company_id == null) {
      // console.log(body.company_id);
      body.company_id = this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '0';
      // console.log(body.company_id);

    }
    if (body.user_id == '' || body.user_id == undefined || body.user_id == null) {
      body.user_id = this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0';
    }
    body.is_vendor = this.get('ven_role',localStorage.getItem('ven_role')) == 'vendor' ? "1" : '0';
    if (body.is_vendor == "1") {
      body.vendor_id = body.user_id;
    }
    // setting module name and module id to from which screen your hitting api
    body.module_name = this.getModule(page_url).menuName ? this.getModule(page_url).menuName : '';
    // body.module_id = this.getModule(page_url).id ? this.getModule(page_url).id : '';
    if (body.module_id == '' || body.module_id == undefined || body.module_id == null) {
      body.module_id = this.getModule(page_url).id ? this.getModule(page_url).id : '';
    }
    if (body.url == '' || body.url == undefined || body.url == null) {
      body.url = page_url ? page_url : ''
    }
    // console.log(this.get('emp_role',localStorage.getItem('emp_role')));
    body.user_role_id=(this.get('emp_role',localStorage.getItem('emp_role'))==''||this.get('emp_role',localStorage.getItem('emp_role'))==undefined)?'':(this.get('emp_role',localStorage.getItem('emp_role'))?this.get('emp_role',localStorage.getItem('emp_role')):'0')
    // body.company_id=body.user_role_id==''?'':body.company_id;

    if(data.public_reg && data.public_reg == '1') {
      
    } else {
      body.company_id=body.user_role_id==''?'0':body.company_id;
    }
    
    // console.log(url);
    if(body.company_id=='' &&this.isAdminUrl(url))
    {
      body.company_id='0';
    }
    if(body.company_id=='0' && body.user_role_id=='')
    {
      body.user_role_id='administrator';
    }
    if(url=='/Vendor_management/loginVendor'||url=='/login/ajax_login')
    {
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
      // body.log_iv=_iv
    }
    let endPoint = ''
    let today:Date=new Date();
    body.request_start_time=today.getHours()+":"+today.getMinutes()+":"+today.getSeconds()+":"+today.getMilliseconds()
    endPoint = this.urlEndPoint + url;
    let dbTime=0
    if(url=="/products/po_product_dropdown_optimize"||url=="products/po_product_dropdown_optimize")
    {
      dbTime=10000
     // console.log(dbTime)
    }
    if(url=="/login/social_login")
    {
  body.company_id='0'
    }
    if(url=="authorization/validate_otp")
    {
      body.company_id='0'
    }

    return this.http.post(endPoint, body, { headers: headers })
      // .pipe(debounceTime(dbTime),distinctUntilChanged())
      .map((response: Response) =>  response.json() as CustomResponse) // Calling json() as CustomResponse on the response to return data in JSON format of type CustomResponse
      // .catch((error: any) => Observable.throw(error || 'Server Error'));
      .catch(
        (error: Response) => {
          let payload: any = {
            "request_url": endPoint,
            "request": body,
            "response": error,
          }
          if (url != '/User_activity/ajax_submit_crash_report') {
            this.commonPostErrorRepoter('/User_activity/ajax_submit_crash_report', payload);
          }
          return Observable.throw(error);
        }
      );
  }

  tpFileRequest(url: any, file: File, authorization: any = "") {
    let headers = new Headers();
    headers.append('Mode', 'Buyer');
    headers.append('Productid', 'arap');
    headers.append('Authorization', "JWT "+authorization);
    headers.append('Subid', '189323');
    
    const formData = new FormData();
    formData.append('file_url', file);

    return this.http.post(url, formData, { headers })
      .map((response: Response) =>  response.json() as CustomResponse)
    ;

  }

  // Method specifically for file uploads using FormData
  commonPostMethodForFileUpload(url, formData) {
    let headers = new Headers();
    // Don't set Content-Type for FormData - let the browser set it with boundary
    headers.append('Accept', 'application/json');
    headers.append('authorization', this.getAccessToken());
    
    if(this.getUserAccessToken()!='') {
      headers.append('user_token', this.getUserAccessToken());
    }

    // Add common fields to FormData (similar to commonPostMethod)
    let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    
    // Add company_id if not already present
    if (!formData.has('company_id')) {
      formData.append('company_id', this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '0');
    }
    
    // Add user_id if not already present
    if (!formData.has('user_id')) {
      formData.append('user_id', this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0');
    }
    
    // Add is_vendor flag
    formData.append('is_vendor', this.get('ven_role',localStorage.getItem('ven_role')) == 'vendor' ? "1" : '0');
    
    // Add vendor_id if user is vendor
    if (this.get('ven_role',localStorage.getItem('ven_role')) == 'vendor') {
      formData.append('vendor_id', this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0');
    }
    
    // Add module information
    formData.append('module_name', this.getModule(page_url).menuName ? this.getModule(page_url).menuName : '');
    if (!formData.has('module_id')) {
      formData.append('module_id', this.getModule(page_url).id ? this.getModule(page_url).id : '');
    }
    
    // Add URL
    if (!formData.has('url')) {
      formData.append('url', page_url ? page_url : '');
    }
    
    // Add user role ID
    formData.append('user_role_id', (this.get('emp_role',localStorage.getItem('emp_role'))==''||this.get('emp_role',localStorage.getItem('emp_role'))==undefined)?'':(this.get('emp_role',localStorage.getItem('emp_role'))?this.get('emp_role',localStorage.getItem('emp_role')):'0'));
    
    // Add time zone
    if (!formData.has('time_zone')) {
      formData.append('time_zone', Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'Asia/Calcutta');
    }
    
    // Add request start time
    if (!formData.has('request_start_time')) {
      let today: Date = new Date();
      formData.append('request_start_time', today.getHours()+":"+today.getMinutes()+":"+today.getSeconds()+":"+today.getMilliseconds());
    }
    
    // Add default values for file upload specific fields
    if (!formData.has('is_remove_keys')) {
      formData.append('is_remove_keys', '0');
    }
    // if (!formData.has('keys_list')) {
    //   formData.append('keys_list', '[]');
    // }

    let endPoint = this.urlEndPoint + url;
    
    return this.http.post(endPoint, formData, { headers })
      .map((response: Response) => {
        try {
          const responseText = response.text();
          
          if (responseText === 'true' || responseText === 'false') {
            return responseText;
          }
          
          return JSON.parse(responseText) as CustomResponse;
        } catch (e) {
          return response.text();
        }
      })
      .catch(
        (error: Response) => {
          console.error('HTTP error:', error);
          console.error('Error text:', error.text());
          return Observable.throw(error);
        }
      );
  }

  tpHttpRequest(url: any, body: any) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    
    return this.http.post(url, body, { headers })
      .map((response: Response) =>  response.json() as CustomResponse)
    ;

  }

  commonGetMethod(url){
    let headers = new Headers();
    let endPoint = this.urlEndPoint + url;

    headers.append('Content-Type', 'application/json');
    headers.append('Productid', 'arap');
    headers.append('authorization', this.getAccessToken())
    endPoint = this.urlEndPoint + url;
    return this.http.get(endPoint, { headers: headers })
    .map((response: Response) =>  response.json() as CustomResponse) // Calling json() as CustomResponse on the response to return data in JSON format of type CustomResponse
    // .catch((error: any) => Observable.throw(error || 'Server Error'));
    .catch(
      (error: Response) => {
        let payload: any = {
          "request_url": endPoint,
          "response": error,
        }
        if (url != '/User_activity/ajax_submit_crash_report') {
          this.commonPostErrorRepoter('/User_activity/ajax_submit_crash_report', payload);
        }
        return Observable.throw(error);
      }
    );
  }

  dynamicWidth(len) {
    let totalWidth = 800;
    let t = Math.round(totalWidth / len);
    let x = Array(len + 1).join("::" + t).split("::");
    return x.filter((data) => {
      return data != '';
    });
  }
  downloadPDF(list: any, saveName: string) {
    let column: string[] = Object.keys(list[0]);
    let pdfHeader: any[] = [];
    let pdfContent: any;
    let cw: string[] = [];
    let wrapList = this.dynamicWidth(column.length);
    for (let m in column) {
      pdfHeader.push({ title: column[m], dataKey: column[m] });
      cw.push('"' + column[m] + '"' + ": {" + '"columnWidth"' + ": " + Number(wrapList[m]) + "}");
    }
    let colWidth: any = '{' + cw.join(",") + '}';
    colWidth = JSON.parse(colWidth);
    pdfContent = '[';
    for (let i = 0; i < list.length; i++) {
      let x: string[] = [];
      for (let j = 0; j < column.length; j++) {
        x.push('"' + [column[j]] + '"' + ":" + '"' + (list[i][column[j]] == undefined ? '' : list[i][column[j]]) + '"');
      }
      pdfContent += '{' + x.join(",") + '},';
    }
    pdfContent = pdfContent.substring(0, pdfContent.length - 1);
    pdfContent += ']';
    pdfContent = JSON.parse(pdfContent);
    let doc = new jsPDF('l', 'pt');
    let totalPagesExp = "{total_pages_count_string}";
    doc.autoTable(pdfHeader, pdfContent, {
      theme: "plain",
      margin: { top: 10, bottom: 10, left: 10, right: 10 },
      styles: { fontSize: 7, cellPadding: 3, overflow: 'linebreak', columnWidth: 'wrap' },
      columnStyles: colWidth,
      addPageContent: function (data: any) {
        let pagination = data.pageCount;
        if (typeof doc.putTotalPages === 'function') {
          pagination = pagination + "/" + totalPagesExp;
        }
        doc.setFontSize(9);
        doc.text(pagination, 810, doc.internal.pageSize.height - 50);
      }
    });
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    doc.save(saveName + '.pdf');
  }

  downloadCSV(list: any, saveName: any) {
    let column: string[] = Object.keys(list[0]);
    let col: string[] = Object.keys(list[0]);
    for (let c in col) {
      col[c] = col[c];
    }
    let csv: string = "";
    csv += col.join(",");
    csv += "\n";
    for (let i = 0; i < list.length; i++) {
      let x: string[] = [];
      for (let j = 0; j < column.length; j++) {
        x.push(list[i][column[j]]);
      }
      csv += x.join(",");
      csv += "\n";
    }
    let hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = saveName + '.csv';
    hiddenElement.click();
  }
  padValue(value): string {
    return (Number(value) < 10) ? "0" + value : value;
  }

  formatDate(date, format, seperator, isTime?: boolean) {
   if (date=='NaN-NaN-'||date == '-NaN-NaN' || date == 'NaN-NaN-NaN' || date == '' || date == undefined || date == null) {
      return;
    }
    if (date != "" && date != undefined) {
      let d = new Date(date),
        mm = '' + (d.getMonth() + 1),
        mmm: any = d.getMonth(),
        dd = '' + d.getDate(),
        yy = d.getFullYear() ? d.getFullYear() : '';
      let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      if (mm.length < 2) mm = '0' + mm;
      if (dd.length < 2) dd = '0' + dd;
      let part = format.split(seperator);
      mmm = month_names[mmm];
      let sHour = d.getHours();
      let sMinute = this.padValue(d.getMinutes());
      let sAMPM = "AM";
      let iHourCheck = Number(sHour);
      if (iHourCheck > 12) {
        sAMPM = "PM";
        sHour = iHourCheck - 12;
      }
      else if (iHourCheck === 0) {
        sHour = 12;
      }
      let sHourPadded = this.padValue(sHour);
      try {
        if (isTime) {
          return eval(part[0]) + seperator + eval(part[1]) + seperator + eval(part[2]) + " " + sHourPadded + ":" + sMinute + " " + sAMPM;
        }

        // if(Intl.DateTimeFormat().resolvedOptions().timeZone=="Asia/Calcutta" || Intl.DateTimeFormat().resolvedOptions().timeZone=="Asia/Kolkata" 
        //    || Intl.DateTimeFormat().resolvedOptions().timeZone=="Europe/London" || Intl.DateTimeFormat().resolvedOptions().timeZone=="Asia/Colombo")
        // {
          return eval(part[0]) + seperator + eval(part[1]) + seperator + eval(part[2]);
        // }
        // else
        // {
        //   let t=eval(part[1]) + seperator + eval(part[2]) + seperator + eval(part[0]);
        //   // console.log(t)
        //   return t;

        // }
      }
      catch (e) {
        return '';
      }
    }
  }

  capitalize(name: string) {
    name = name.toLowerCase();
    return name.trim().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() });
  }
  imageList() {
    return [
      'image/png',
      'image/jpeg',
      'image/jpg',
      'image/gif',
    ]
  }
  getDynamicUrl() {
    const runtimeApiBaseUrl = this.runtimeConfigService.getApiBaseUrl();

    if (runtimeApiBaseUrl) {
      this.urlEndPoint = runtimeApiBaseUrl.endsWith('/') ? runtimeApiBaseUrl : runtimeApiBaseUrl + '/';
      return;
    }

    if (window.location.hostname == "localhost") {
      // Production
  //  this.urlEndPoint = "https://staging.tyasuite.com/prapp/index.php/";
   this.urlEndPoint = "https://qa.intelaccounts.in/prapp/index.php/";
    }
     else {
    //   // this.urlEndPoint = "https://" + window.location.host + "/prapp/index.php/";
            this.urlEndPoint = "https://api.intelaccounts.in/prapp/index.php/";
    }

    if (window.location.hostname == "qa.intelaccounts.in" || window.location.hostname == "localhost") {
      this.chatbotUrl = "https://qa-ai.tyasuite.in";
    } else {
      this.chatbotUrl = "https://ai.tyasuite.in";
    }
  }
  removeWhiteSpace(data)
  {
    if(data==''||data==undefined||data==null)
    {
      return '';
    }
    else
    {
      data=data.toString?data.toString():'';
      return data.trim();
    }
  }

  focusToMultiSelectSearch(elem: any) {
    elem = elem.target;
    if (elem.classList.contains('dropdown-down')) {
      return;
    } else if (elem.classList.contains('dropdown-up')) {
      elem = elem.parentNode.parentNode;
    }
    elem.parentNode.nextElementSibling.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.focus();
  }

  focusToSingleSelectSearch(elem: any) {
    elem = elem.target;
    if (elem.classList.contains('dropdown-down')) {
      return;
    } else if (elem.classList.contains('dropdown-up')) {
      elem = elem.parentNode.parentNode;
    }
    elem.parentNode.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.focus();
  }

  makeFocusById(id: string) {
    if(document.getElementById(id)!=null && document.getElementById(id)!=undefined)
    {
    setTimeout(() => {
      document.getElementById(id).focus()
    }, 500);
  }
  }


  getFilename(name) {
    return name.substring(0, name.lastIndexOf('.'));


  }
  getFileExtension(filename) {
    return (filename!=''&&filename!=undefined&&filename!=null)?filename.split('.').pop():'';
  }
  getFileIcon(type) {
    let class_name: any = "fa fa-file-text-o";

    switch (type.toLowerCase()) {
      case 'pdf':
        class_name = "fa fa-file-pdf-o";
        break;
      case 'png':
        class_name = "fa fa-file-image-o";
        break;
      case 'jpg':
        class_name = "fa fa-file-image-o";
        break;
      case 'jpeg':
        class_name = "fa fa-file-image-o";
        break;
      case 'gif':
        class_name = "fa fa-file-image-o";
        break;
      case 'bmp':
        class_name = "fa fa-file-image-o";
        break;
      case 'txt':
        class_name = "fa fa-file-text-o";
        break;
      case 'tif':
        class_name = "fa fa-file-text-o";
        break;
      case 'tiff':
        class_name = "fa fa-file-text-o";
        break;

      case 'doc':
        class_name = "fa fa-file-word-o";
        break;
      case 'docx':
        class_name = "fa fa-file-word-o";
        break;
      case 'rtf':
        class_name = "fa fa-file-word-o";
        break;
      case 'wks':
        class_name = "fa fa-file-word-o";
        break;
      case 'wps':
        class_name = "fa fa-file-word-o";
        break;
      case 'wpd':
        class_name = "fa fa-file-word-o";
        break;

      case 'xlr':
        class_name = "fa fa-file-excel-o";
        break;
      case 'xls':
        class_name = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        class_name = "fa fa-file-excel-o";
        break;
      case 'csv':
        class_name = "fa fa-file-excel-o";
        break;

      case 'ppt':
        class_name = "fa fa-file-powerpoint-o";
        break;

      case 'pps':
        class_name = "fa fa-file-powerpoint-o";
        break;
      case 'pptx':
        class_name = "fa fa-file-powerpoint-o";
        break;
        case 'msg':
          class_name = "fa fa-envelope-open-o";
          break;
        case 'eml':
          class_name = "fa fa-file-o";
          break;
        case 'zip':
          class_name = "fa fa-file-zip-o";
          break;
      default:
        class_name = "fa fa-file-text-o";

    }

    return class_name;


  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  removeDuplicates(myArr, prop) {
    myArr=Array.isArray(myArr)?myArr:[];
    if(myArr.length>0)
    {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj =>
        mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }
  else
  {
    return myArr;
  }
  }

  // to open external link
  goToUrl(url, isNewPage) {
    if (!isNewPage) {
      this.router.navigate([url]);
    }
    else {
      window.open(url, '_blank');
    }
  }
  isInt(n) {
    return Number(n) === n && n % 1 === 0;
  }
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  Older_convertNaN(value) {
    if (this.isFloat(value)) {
      value = parseFloat(value).toFixed(2) || 0
    }
    else {
      value = value || 0
    }
    if (isNaN(value)) {
      value = 0;
    }
    let t = value || 0
    return t;
  }
  // convertNaN(value, limit?:any) {
  //   limit = limit ? limit : 2;

  //   if(limit > 0) {
  //     value = parseFloat(value);
  //   }
  //   if (this.isFloat(value)) {
  //     let data=(value+"").split(".")[1]?(value+"").split(".")[1]:'';
  //     if(limit > 0) {

  //       if(data.length > limit) {
  //         value = value.toString().match('^-?\\d+(?:\.\\d{0,' + limit + '})?')[0]
  //         value = parseFloat(value).toFixed(limit) || 0
  //       } else {
  //         value = parseFloat(value).toFixed(data.length) || 0
  //       }
  //     } 
  //     else if(data.length>2)
  //     {
  //       value = parseFloat(value).toFixed(limit) || 0

  //     }
  //     else if(data.length==1)
  //     {
  //       value = parseFloat(value).toFixed(limit) || 0

  //     }
  //     else
  //     {
  //       value = parseFloat(value).toFixed(limit) || 0

  //     }
  //   }
  //   else {
  //     value = value || 0
  //   }
  //   if (isNaN(value)) {
  //     value = 0;
  //   }
  //   if(value=="Infinity")
  //   {
  //     value=0;
  //   }
  //   let t = value || 0
  //   return t;
  // }
  convertNaN(value, limit?: any) {
    limit = limit ? limit : 2;

    if (value === null || value === undefined || isNaN(value) || value === '') {
      return '0'; // Return '0' if invalid value
    }

    if (!isNaN(value) && value !== '') {
      let [integerPart, decimalPart] = value.toString().split('.');
      if (decimalPart && decimalPart != undefined && decimalPart.length > limit) {
        // decimalPart = decimalPart.substring(0, limit);
        value = parseFloat(value).toFixed(limit);
      }
      // value = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    } else {
      value = '0';
    }

    if (isNaN(value)) {
      value = '0';
    }
    if (value == "Infinity") {
      value = '0';
    }
    return value;
  }
  
  convertToZero(value) {
    return parseFloat(value) >= 1 ? value : 0;
  }
  validateAllowNumber(num) {
    let x = /^[1-9][0-9]{0,100}$/
    return x.test(num)
  }
  validateEmail(email) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let status = false;
    if (reg.test(email) == false) {
      status = false;
    }
    else {
      status = true;
    }
    return status;
  }
  validmobile(mobile) {
    let status = false;
    let no: number = mobile;
    let len: number = 0;
    if (mobile != '' && mobile != undefined) {
      len = mobile.length;
      no = mobile;
      if (this.validateAllowNumber(no) && len == 10) {
        status = true;
      }
      else {
        status = false;
      }
    }
    return status;
  }
  makeZeroBlank(event) {
    event.value = event.value == '0' ? '' : event.value;
  }
  setInputWidth(value) {
    if (value == '' || value == null || value == undefined) {
      return '50px';
    }
    return ((value.length + 1) * 8) + 'px';

  }

  deviceInfo: any = {};


  makeAttachment(attachment_array) {
    // console.log(attachment_array);
    let attachments: any = [];
    if (attachment_array)
      for (let d of attachment_array) {
        if(d.attachment!='' && d.attachment!=null && d.attachment!=undefined)
        {
        d.attachment=d.attachment?d.attachment:'';
          let url=d.attachments_url?d.attachments_url:d.attachment_url
          let extension=this.getFileExtension(url)?this.getFileExtension(url):this.getFileExtension(d.attachment)
          if(extension.length>20)
          {
            extension=this.getFileExtension(url)
          }
        attachments.push({
          "url": url,
          "name": d.attachment_name,
          "display": url,
          "filename": d.attachment_name,
          "filetype": extension,
          "iconclass": this.getFileIcon(extension),
          "attachment_type":d.display ?d.display :extension,
          "additional_savedFiles":d.additional_savedFiles ? d.additional_savedFiles:[],
        });
      }
      }
    return attachments ? attachments : []
  }
  numberWithCommas(x, limit ?, type ?, showComma ?) {
    showComma = showComma ? showComma : '2';
    if(showComma=='0') {
      // return x;
      type = 'Foreign';
    }
    type = type ? type : 'Foreign';
    limit = limit ? limit : 2;
    let format: any = '';
    if (x == undefined || x == '') {
      x = this.convertNaN(x) ? this.convertNaN(x, limit) : '0';

      return x;
    }
    x = this.convertNaN(x) ? this.convertNaN(x, limit) : '0';
    if(type=='IND') {
      return this.formatIndianNumberSystem(x);
    }
    format = localStorage.getItem('number_format') ? localStorage.getItem('number_format') : ','
    let parts = x.toString().split(".");
    if(parts.length > 1) {
      let parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, format);
    }
  }

  formatIndianNumberSystem(value: string): string {
    if (!value) return '';
    let formattedValue = value.toString();
    let [integerPart, decimalPart] = formattedValue.split('.');
    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);
    if (otherNumbers != '') {
      lastThree = ',' + lastThree;
    }
    let formattedIntegerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return decimalPart ? formattedIntegerPart + '.' + decimalPart : formattedIntegerPart;
  }

  makeWrongDateEmpty(date) {
    let temp: any = date;
    switch (date) {
      case '0000-00-00':
        temp = '';
        break;

      case 'NaN-NaN-NaN':
        temp = '';
        break;
      case 'NaN-Nan-NaN':
      temp = '';
      break;
      case '-NaN-NaN':
        temp = '';
        break;
      case '-NaN':
        temp = '';
        break;
      case 'null':
        temp = "";
        break;
      case '1970-01-01':
          temp = "";
          break;
      default:
        temp = date;
    }
    return temp;
  }
  arrayForSearch: any = [];

  prepareMenuList() {
    let data: any = [];
    data = this.get('menus',localStorage.getItem("menus")) ? this.get('menus',localStorage.getItem("menus")) : [];
    this.arrayForSearch = [];
    let mainMenuList: any = [];
    let subMenuList: any = []
    for (let x of data) {
      if (x.aurl != '#') {
        mainMenuList.push({
          "id": x.id,
          "menuName": x.menuitemname,
          "url": x.aurl,
          "project": x.project,
        })
      }

      if (x.submenu)
        for (let d of x.submenu) {
          subMenuList.push({
            "id": d.id,
            "menuName": d.menuitemname,
            "url": d.aurl,
            "project": d.project,
          })
        }
      this.arrayForSearch = subMenuList.concat(mainMenuList);
    }
  }
  checkModuleUrl(url)
  {
    switch(url)
    {
      case '/raise-rejected-inv':
        url='/direct-invoice';
        break;
        case '/raise-draft-direct-invoice':
          url='/direct-invoice';
          break;
          case '/raise-draft-po':
            url='/direct-po';
            break;
            case '/raise-draft-pr':
              url='/raisepr';
              break;
      default:;
    }
    return url;
  }
  getModule(url) {
    url=this.checkModuleUrl(url);
    if (this.arrayForSearch.length <= 0 || this.arrayForSearch.length == undefined) {
      this.prepareMenuList();

    }
    let temp: any = [];
    temp = this.arrayForSearch.filter((v) => { return v.url == url })
    return temp[0] ? temp[0] : '';

  }
  redirectURL(url: string) {
    const path = applyUiModeToRedirectPath(url.startsWith('/') ? url : '/' + url);
    this.router.navigateByUrl(path).catch(() => {
      setTimeout(() => {
        this.router.navigateByUrl(path);
      }, 2000);
    });
  }
  getNumberFromString(data) {
    let str = data.replace(/[^\d.]/g, '');
    return str ? str : ''
  }
  checkType(x) {
    if (x.includes('grn')) {
      return 'grn';
    }
    else if (x.includes('invoice')) {
      return 'invoice';
    }
    else {
      return '';
    }
  }
  menuIdCheck(dataArray) {
    let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    let status: any = '0';
    let body: any = { "id": '' };
    body.module_id = this.getModule(page_url).id ? this.getModule(page_url).id : '';

    dataArray = dataArray ? dataArray : [];
    if (dataArray.length != undefined && dataArray.length > 0 && body.module_id != '' && body.module_id != undefined) {
      if (dataArray.some((v) => { return v.item_id == body.module_id })) {
        status = '1';
      }
    }
    return status;
  }

  changeTextCase(data, data_case) {
    data = data ? data : ''

    if (data == '' || data == undefined || data == null) {
      return data ? data : ''
    }

    switch (data_case) {
      case 'uppercase':
        data = data.toUpperCase() ? data.toUpperCase() : '';
        break;
      case 'capitalize':
        data = data.toLowerCase()
          .split(' ')
          .map(function (word) {
            return word[0].toUpperCase() + word.substr(1);
          })
          .join(' ');
        break;
      default:

    }

    return data ? data : '';

  }
  getCurrencyIcon(code,classname) {
    let icon = '';

    if (code == '' || code == undefined || code == null) {
      return icon;
    }
    code = code.toLowerCase() ? code.toLowerCase() : '';
    switch (code) {
      case 'usd':
        icon = "fa fa-usd "+classname;
        break;
      case 'inr':
        icon = "fa fa-inr "+classname;
        break;
      case 'krw':
        icon = "fa fa-krw "+classname;
        break;
      case 'krw':
        icon = "fa fa-krw "+classname;
        break;
      case 'won':
        icon = "fa fa-krw "+classname;
        break;
      case 'jpy':
        icon = "fa fa-jpy "+classname;
        break;
      case 'yen':
        icon = "fa fa-jpy "+classname;
        break;
      case 'rmb':
        icon = "fa fa-jpy "+classname;
        break;
      case 'cny':
        icon = "fa fa-jpy "+classname;
        break;
      case 'gbp':
        icon = "fa fa-gbp "+classname;
        break;
      case 'eur':
        icon = "fa fa-eur "+classname;
        break;
      case 'rub':
        icon = "fa fa-rub "+classname;
        break;
      case 'try':
        icon = "fa fa-try "+classname;
        break;
      case 'ils':
        icon = "fa fa-ils "+classname;
        break;
      case 'gg':
        icon = "fa fa-gg "+classname;
        break;
      case 'bdt':
        icon = "fa bdt_icon "+classname;
        break;
      case 'rsd':
        icon = "fa fa-rsd "+classname;
        break;
      default:
        icon = '';
    }
    return icon ? icon : '';
  }
  getMenuNameByUrl()
  {
    let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let name:any=-'';
    let array:any=[];
    array = this.get('menus',localStorage.getItem("menus")) ? this.get('menus',localStorage.getItem("menus")) :[];

    if(array)
    {
      for(let i of array)
      {
        i.submenu=i.submenu?i.submenu:[]
        if(i.submenu)
        {
          let t:any=[];
          t=i.submenu.filter((v)=>{return v.aurl==url});
          if(t.length>0)
          {
            name=t[0].menuitemname?t[0].menuitemname:'';
          }
        }
      }
    }

    return name?name:''
  }
  getMainMenuNameByUrl()
  {
    let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let name:any=-'';
    let array:any=[];
    array =this.get('menus',localStorage.getItem("menus")) ?this.get('menus',localStorage.getItem("menus")) :[];

    if(array)
    {
      for(let i of array)
      {
        i.submenu=i.submenu?i.submenu:[]
        if(i.submenu)
        {
          let t:any=[];
          t=i.submenu.filter((v)=>{return v.aurl==url});
          if(t.length>0)
          {
            name=i.menuitemname?i.menuitemname:'';
          }
        }
      }
    }

    return name?name:''
  }
  getMainMenuNameByGivenUrl(url)
  {
    // let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let name:any=-'';
    let array:any=[];
    array = this.get('menus',localStorage.getItem("menus")) ? this.get('menus',localStorage.getItem("menus")) :[];

    if(array)
    {
      for(let i of array)
      {
        i.submenu=i.submenu?i.submenu:[]
        if(i.submenu)
        {
          let t:any=[];
          t=i.submenu.filter((v)=>{return v.aurl==url});
          if(t.length>0)
          {
            name=i.menuitemname?i.menuitemname:'';
          }
        }
      }
    }

    return name?name:''
  }
  getMenuByUrl(url)
  {
    // let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let name:any={};
    let array:any=[];
    array = this.get('menus',localStorage.getItem("menus")) ? this.get('menus',localStorage.getItem("menus")) :[];

    if(array)
    {
      for(let i of array)
      {
        i.submenu=i.submenu?i.submenu:[]
        if(i.submenu)
        {
          let t:any=[];
          t=i.submenu.filter((v)=>{return v.aurl==url});
          if(t.length>0)
          {
            name=i?i:{'id':'',parent_id:''};
          }
        }
      }
    }

    return name?name:{'id':'',parent_id:''};
  }
  is_Valid_Action(actionList,name,companySelectionDisabled)
  {
    if(name==''||name==undefined)
    {
      return false;
    }
    if(!companySelectionDisabled)
    {
      return true;
    }
    return actionList.some((v)=>{return v.action_name==name});
  }
  convertHtmlDataToNormalText(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  IS_VAILID_URL(url)
  {
    // let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let name:any=-'';
    let status:boolean=false;
    let array:any=[];
    array = this.get('menus',localStorage.getItem("menus")) ? this.get('menus',localStorage.getItem("menus")) :[];

    if(array)
    {
      for(let i of array)
      {
        i.submenu=i.submenu?i.submenu:[]
        if(i.submenu)
        {
          let t:any=[];
          t=i.submenu.filter((v)=>{return v.aurl==url});
          if(t.length>0)
          {
            name=t[0].menuitemname?t[0].menuitemname:'';
            status=true;
          }
        }
      }
    }

    return status?status:false
  }
  getColumnName(column_list,key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (column_list.length == undefined || column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  is_column_visible(column_list,key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (column_list.length == undefined || column_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
  is_column_mandatory(column_list,key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    if (column_list.length == undefined || column_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }

    return temp[0].is_mandatory ? temp[0].is_mandatory : false
  }
  is_column_mandatory_and_visible(column_list,key, default_data, key2?:any) {
     key2 = key2 ? key2 : "";
    let status:boolean=default_data;
    if (key == '' || key == undefined) {
        return default_data ? default_data : false;
    }
    if (column_list.length == undefined || column_list.length <= 0) {
        return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
        return default_data ? default_data : false;
    }
     if(key2!="") {
      return (temp[0][key2])?true:default_data;
    } else {
      return (temp[0].is_mandatory &&temp[0].is_visible)?true:false;
    }


  }

  vendor_is_column_mandatory_and_visible(column_list,key, default_data) {
    let status:boolean=default_data;
    if (key == '' || key == undefined) {
        return default_data ? default_data : false;
    }
    if (column_list.length == undefined || column_list.length <= 0) {
        return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
        return default_data ? default_data : false;
    }
     return (temp[0].is_mandatory &&temp[0].vendor_login_visible)?true:false;

  }

  getColor(range)
  {
    let color:any='red';
   if(range<=30)
   {
        color='red';
       }
      if(range>30 && range<=60)
      {
          color='orange';
         }
      if(range>60 && range<=80)
      {
            color='blue';
      }
      if(range>60 && range<100)
      {
              color='gray';
             }
      if(range==100)
      {
                color='green';
      }

    // console.log('color='+color+'for range='+range);
    return color?color:'';
  }
  returnData(array, id,default_value) {
    let temp: any = [];
    array=Array.isArray(array)?array:[];
    if(array.length!=undefined)
    {
    temp = array.filter((v) => { return v.id == id })
    // console.log(id)
    // console.log(array)
    if (temp.length > 0) {
      return temp[0];
    }
    return { "name": '', "Code": '','default_value':default_value,'custom_title':default_value,'full_name':default_value ,'is_visible':default_value };
  }
    return { "name": '', "Code": '','default_value':default_value,'custom_title':default_value,'is_visible':default_value };

}
  checkDecimal(event, limit?) {
    limit = limit ? limit : 2;
    let data:any={'target':{value:''}};
    let inputValue = event.target.value;
    data=event?event:{'target':{value:''}};
    if(parseFloat(this.convertNaN(data.target.value))>0)
    {

      let value = data.target.value;
      if(limit > 0) {
        value=this.convertNaN(data.target.value, limit)?this.convertNaN(data.target.value, limit):'0'
      } else {
        value=this.convertNaN(data.target.value)?this.convertNaN(data.target.value):'0'
      }
      if (inputValue === '' || !isNaN(Number(inputValue))) {
        if (inputValue.includes('.')) {
          let [integerPart, decimalPart] = inputValue.split('.');
          if (decimalPart.length > limit) {
            decimalPart = decimalPart.substring(0, limit);
          }
          inputValue = `${integerPart}.${decimalPart}`;
        }
        event.target.value = inputValue.toString();
        return inputValue;
      }

    value=parseFloat(value);
    if (this.isFloat(value)) {

      let data=(value+"").split(".")[1]?(value+"").split(".")[1]:'';
      if(limit > 0) {
        // console.log("data", data, data.length)
        if(data.length > limit) {
          event.target.value = parseFloat(value).toFixed(limit) || 0
          return false;  
        } else {
          event.target.value = parseFloat(value).toFixed(data.length) || 0
          return false;
        }
      } 
      else if(data.length>2)
      {
        event.target.value = parseFloat(value).toFixed(2) || 0
        return false;

      }

    }
  }
  else
  {

  }
  }
  removeWhiteSpace1(data)
  {
    if(data==''||data==undefined||data==null)
    {
      return '';
    }
    else
    {
      data=data.toString?data.toString():'';
      return data.trim();
    }
  }

  getMonthListWithName(){
    let MonthArray:any = [];
    MonthArray = [
      {'month_id':'1','month_name':'January'},
      {'month_id':'2','month_name':'February'},
      {'month_id':'3','month_name':'March'},
      {'month_id':'4','month_name':'April'},
      {'month_id':'5','month_name':'May'},
      {'month_id':'6','month_name':'June'},
      {'month_id':'7','month_name':'July'},
      {'month_id':'8','month_name':'August'},
      {'month_id':'9','month_name':'September'},
      {'month_id':'10','month_name':'October'},
      {'month_id':'11','month_name':'November'},
      {'month_id':'12','month_name':'December'},
    ];
    return MonthArray
  }
  getFrequencyListWithName(){
    let dataArray:any = [];
    dataArray = [
      {'id':'daily','name':'Daily'},
      {'id':'weekly','name':'Weekly'},
      {'id':'15_days','name':'15 Days'},
      {'id':'monthly','name':'Monthly'},
      {'id':'quarterly','name':'Quarterly'},
      {'id':'half_yearly','name':'Half-Yearly'},
      {'id':'yearly','name':'Yearly'}
    ];
    return dataArray
  }
  getDayListWithName(){
    let dataArray:any = [];
    for(let i=0;i<=31;i++)
    {
      dataArray.push({'id':i.toString(),'name':i.toString()})
    }
    return dataArray
  }
raiseScreenList:any=['raisePoNew']
makeSearchFocusById(id: string) {
  let d:any=document.getElementById(id)?document.getElementById(id):''
  if(d!='' && d!=null && d!=undefined)
  {
  setTimeout(() => {
    document.getElementById(id).focus();
  }, 1000);
}
}
set(value,key?:string)
{
  // console.log(value);
  // console.log(key);
// try{
//   if(localStorage.getItem('is_enc_on')=='MQ=='||key=='is_enc_on'||key=='is_login_psw')
//   // if(localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     return btoa(value);
//   }
//   else
//   {
//     return value
//   }
// }
// catch(e)
// {
// return value
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try{
   if(localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='||key=='is_enc_on'||key=='is_login_psw')
   {
    return CryptoJS.AES.encrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString();
   }
  }
   catch(e)
   {
     console.log(e.name);
     console.log(e.message);
return value
   }

}
get(key,value,is_cookie?:string)
{
//   try {
//   if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     // console.log('hey3');

//     return (atob(value)!=''&&atob(value)!=undefined&&atob(value)!=null)?(this.isJSON(atob(value))?JSON.parse(atob(value)):atob(value)):value;

//   }
//   else
//   {
//     return (this.isJSON(value)?JSON.parse(value):value);
//   }
// }
// catch(e)
// {
//   console.error('enc/dec logout key'+key,'value='+value)
//   window.localStorage.clear();
//   window.location.href=window.location.origin+"/#/login"
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try {
  if(is_cookie!='1')
  {
    if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg==')
    {
      let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
      return this.isJSON(dec)?JSON.parse(dec):dec;
     }
    }
     if(is_cookie=='1')
     {
       let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
       return this.isJSON(dec)?JSON.parse(dec):dec;
      }
  }
  catch(e)
  {
    console.error('enc/dec logout key'+key,'value='+value)
      window.localStorage.clear();
      window.sessionStorage.clear()
      window.location.href=window.location.origin+"/#/login"
      this.redirectURL("/login")
  }

}
isJSON(str) {
  try {
      return (JSON.parse(str));
  } catch (e) {
      return false;
  }
}
handleChangeFile({target}) {
  const files = target.files
  target.value = ''
}
checkIfNameExists(arr, prop, newVal) {
  return arr.some(function(e) {
      return e[prop] ? e[prop] === newVal : false;
  });
}
checkInt(event) {
  let data:any={'target':{value:''}};
  data=event?event:{'target':{value:''}};
  if(parseInt(this.convertNaN(data.target.value))>0)
  {


  let value=this.convertNaN(data.target.value)?this.convertNaN(data.target.value):'0'
  value=parseInt(value);
  if (this.isFloat(value)) {

    let data=(value+"").split(".")[1]?(value+"").split(".")[1]:'';
    if(data.length>2)
    {
      event.target.value = parseInt(value)|| 0
      return false;

    }

  }
  if (this.isInt(value)) {

    let data=value?value:'';
      event.target.value = parseInt(value)|| 0

  }
}
else
{

}
}
searchedData:any = [];
setSearchedData(data) {
  this.searchedData = data
}
getSearchedData() {
  return this.searchedData
}
getCurrencyIconString(code) {
  let icon = '';

  if (code == '' || code == undefined || code == null) {
    return icon;
  }
  code = code.toLowerCase() ? code.toLowerCase() : '';
  switch (code) {
    case 'usd':
      icon = "($)";
      break;
    case 'inr':
      icon = "(₹)";
      break;
    case 'krw':
      icon = "(₩)";
      break;
    case 'krw':
      icon = "(₩)";
      break;
    case 'won':
      icon = "(₩)";
      break;
    case 'jpy':
      icon = "(¥)";
      break;
    case 'yen':
      icon = "(¥)";
      break;
    case 'rmb':
      icon = "(¥)";
      break;
    case 'cny':
      icon = "(¥)";
      break;
    case 'gbp':
      icon = "(£)";
      break;
    case 'eur':
      icon = "(€)";
      break;
    case 'rub':
      icon = "(₽)";
      break;
    case 'try':
      icon = "(₺)";
      break;
    case 'ils':
      icon = "(₪)";
      break;
    case 'gg':
      icon = "";
      break;
    case 'bdt':
      icon = "(৳)";
      break;
    default:
      icon = '';
  }

  return icon ? icon : '';
}

formatDate_v1(dateValue, format, seperator, curFormat : any, isTime ?:boolean) {
  // console.log('date', date.split('-').map(part => parseInt(part, 10)));

  if (dateValue=='NaN-NaN-'||dateValue == '-NaN-NaN' || dateValue == 'NaN-NaN-NaN' || dateValue == '' || dateValue == undefined || dateValue == null) {
    return;
  }

  if(isTime) {
    const date = new Date(dateValue);
    const year = date.getFullYear();
    const month = parseInt((date.getMonth() + 1).toString().padStart(2, '0')); // Months are zero-based
    const day = parseInt(date.getDate().toString().padStart(2, '0'));


    // return `${year}-${month}-${day}`;

    switch (format) {
      case 'dd-mm-yyyy':
          return new Date(year, month, day);
    
      case 'mm-dd-yyyy':
          return new Date(year, month, day);
    
      case 'yy-mm-dd':
          return new Date(year, month-1, day);
    
      // Add more cases as needed for different formats
      default:
          throw new Error('Unsupported date format');
    }
  } else {
   
  // Detect the separator from the input date string
  let inputSeparator: string;
  if (dateValue.includes('/')) {
    inputSeparator = '/';
  } else if (dateValue.includes('-')) {
    inputSeparator = '-';
  } else if (dateValue.includes('.')) {
    inputSeparator = '.';
  } else {
    // Default to the provided separator if no common separator is found
    inputSeparator = seperator;
  }

  let day: number, month: number, year: number;

  switch (curFormat) {
  case 'dd-mm-yyyy':
      [day, month, year] = dateValue.split(inputSeparator).map(part => parseInt(part, 10));
      return new Date(year, month - 1, day);

  case 'mm-dd-yyyy':
      [month, day, year] = dateValue.split(inputSeparator).map(part => parseInt(part, 10));
      return new Date(year, month - 1, day);

  case 'yyyy-mm-dd':
      [year, month, day] = dateValue.split(inputSeparator).map(part => parseInt(part, 10));
      return new Date(year, month - 1, day);
      // Add more cases as needed for different formats
      default:
          throw new Error('Unsupported date format');
    }
  }
}
  JsonDiff(old_record_josn_obj,new_record_josn_obj){
    let result:any= {};
    
    for(var i in new_record_josn_obj) {

      if(!old_record_josn_obj.hasOwnProperty(i) || new_record_josn_obj[i] !== old_record_josn_obj[i]) {
        result[i] = new_record_josn_obj[i];
      }

    }

    if(Object.keys(result).length>0)
    {

      result.diff_found=true;
      result.total_old_record_keys=Object.keys(old_record_josn_obj).length?Object.keys(old_record_josn_obj).length:'0';
      result.old_record_keys=Object.keys(old_record_josn_obj);
      result.total_new_record_keys=Object.keys(new_record_josn_obj).length?Object.keys(new_record_josn_obj).length:'0';
      result.new_record_keys=Object.keys(new_record_josn_obj);

    }
    return result?result:{'diff_found':false,'total_old_record_keys':'0','total_new_record_keys':'0'};
  }
  adjustHeightTextArea(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = '24px'; // Reset height to allow shrink when content is deleted
    textarea.style.height = Math.min(textarea.scrollHeight, 50) + 'px';
  }
  getLocalDate(dateVal) {
    if (dateVal == undefined || dateVal == null || ["", "NaN-NaN-", "-NaN-NaN", "NaN-NaN-NaN", "0000-00-00"].includes(dateVal)) {
      return "";
    }
    let date = new Date(dateVal);
    let localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    return localDate;
  }
  getLocalReqiredDate(dateVal) {
    if(dateVal!=undefined && ["", null, "0000-00-00", "NaN-NaN-", "-NaN-NaN", "NaN-NaN-NaN", ].includes(dateVal)) {
      return dateVal;
    }
    let date = new Date(dateVal);
    let localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    const year = localDate.getFullYear();
    const month = (localDate.getMonth() + 1).toString().padStart(2, '0'); 
    const day = localDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  getLocalReqiredDate_v2(dateVal) {
    if(dateVal!=undefined && ["", null, "0000-00-00", "NaN-NaN-", "-NaN-NaN", "NaN-NaN-NaN", ].includes(dateVal)) {
      return dateVal;
    }
  
    let date = new Date(dateVal);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  parseDateFormat(dateValue: string, currentDateFormat: string ): string | null {
    if (!dateValue || typeof dateValue !== 'string') {
      return null;
    }
  
    let properDate: Date | null = null;
    const dateParts = dateValue.split('/');
  
    if (dateParts.length !== 3) return null;
  
    switch (currentDateFormat) {
      case 'dd/mm/yyyy':
        properDate = new Date(
          parseInt(dateParts[2]),
          parseInt(dateParts[1]) - 1,
          parseInt(dateParts[0])
        );
        break;
  
      case 'mm/dd/yyyy':
        properDate = new Date(
          parseInt(dateParts[2]),
          parseInt(dateParts[0]) - 1,
          parseInt(dateParts[1])
        );
        break;
  
      case 'yyyy/mm/dd':
        properDate = new Date(
          parseInt(dateParts[0]),
          parseInt(dateParts[1]) - 1,
          parseInt(dateParts[2])
        );
        break;
  
      default:
        // Default to dd/mm/yyyy if no format is specified
        properDate = new Date(
          parseInt(dateParts[2]),
          parseInt(dateParts[1]) - 1,
          parseInt(dateParts[0])
        );
    }
  
    // Validate date and format
    if (properDate && !isNaN(properDate.getTime())) {
      return this.formatDate(properDate, 'yy-mm-dd', '-');
    }
  
    return null;
  }  

  CsvTemplate(jeData, company_setup) {
    let data: any = [];
    for(let tmp of jeData) {
      let index = 1;
      for(let i of tmp.jeDetails) {
        let temp = {
          "S.No.": index,
          "Dr/Cr": i.amount_type,
          "Cost Centres": i.cost_centre_name,
          "Project": i.project_name,
          "Product": i.product_name,
          "GL Code": i.account_name,
          "Amount Dr": this.numberWithCommas(i.amount_dr, 2, company_setup.comma_separate_currency_code, company_setup.is_enable_comma_separate_price),
          "Amount Cr": this.numberWithCommas(i.amount_cr, 2, company_setup.comma_separate_currency_code, company_setup.is_enable_comma_separate_price),
          [this.getJEName('dept_code', company_setup)]: i.dept_code,
          [this.getJEName('geo_code', company_setup)]: i.geo_code,
          [this.getJEName('entity_code', company_setup)]: i.entiry_code,
          [this.getJEName('delivery_center_code', company_setup)]: i.delivery_center_code,
          [this.getJEName('employee_code', company_setup)]: i.employee_code,
          [this.getJEName('horizontal_code', company_setup)]: i.horizontal_code,
          [this.getJEName('intercompany_code', company_setup)]: i.intercompany_code,
          [this.getJEName('lob_code', company_setup)]: i.lob_code,
          [this.getJEName('spare2_code', company_setup)]: i.spare2_code,
          "Remarks": i.remarks,
          "Invoice No": i.vendor_invoice_no,
        };
        if(company_setup.is_project_visible_in_allocate_costcenter_in_inv != '1') {
          delete temp["Project"];
        }
        if(!this.IsJeVisible('dept_code', company_setup)) {
          delete temp[this.getJEName('dept_code', company_setup)];
        }
        if(!this.IsJeVisible('geo_code', company_setup)) {
          delete temp[this.getJEName('geo_code', company_setup)];
        }
        if(!this.IsJeVisible('entity_code', company_setup)) {
          delete temp[this.getJEName('entity_code', company_setup)];
        }
        if(!this.IsJeVisible('delivery_center_code', company_setup)) {
          delete temp[this.getJEName('delivery_center_code', company_setup)];
        }
        if(!this.IsJeVisible('employee_code', company_setup)) {
          delete temp[this.getJEName('employee_code', company_setup)];
        }
        if(!this.IsJeVisible('horizontal_code', company_setup)) {
          delete temp[this.getJEName('horizontal_code', company_setup)];
        }
        if(!this.IsJeVisible('intercompany_code', company_setup)) {
          delete temp[this.getJEName('intercompany_code', company_setup)];
        }
        if(!this.IsJeVisible('lob_code', company_setup)) {
          delete temp[this.getJEName('lob_code', company_setup)];
        }
        if(!this.IsJeVisible('spare2_code', company_setup)) {
          delete temp[this.getJEName('spare2_code', company_setup)];
        }
        data.push(temp);
        index++;
      }

      let temp = {
        "S.No.": '',
        "Dr/Cr": '',
        "Cost Centres": '',
        "Project": '',
        "Product": '',
        "GL Code": '',
        "Amount Dr": this.numberWithCommas(tmp.total_amount_dr, 2, company_setup.comma_separate_currency_code, company_setup.is_enable_comma_separate_price),
        "Amount Cr": this.numberWithCommas(tmp.total_amount_cr, 2, company_setup.comma_separate_currency_code, company_setup.is_enable_comma_separate_price),
        [this.getJEName('dept_code', company_setup)]: '',
        [this.getJEName('geo_code', company_setup)]: '',
        [this.getJEName('entity_code', company_setup)]: '',
        [this.getJEName('delivery_center_code', company_setup)]: '',
        [this.getJEName('employee_code', company_setup)]: '',
        [this.getJEName('horizontal_code', company_setup)]: '',
        [this.getJEName('intercompany_code', company_setup)]: '',
        [this.getJEName('lob_code', company_setup)]: '',
        [this.getJEName('spare2_code', company_setup)]: '',
        "Remarks": '',
        "Invoice No": '',
      };
      if(company_setup.is_project_visible_in_allocate_costcenter_in_inv != '1') {
        delete temp["Project"];
      }
      if(!this.IsJeVisible('dept_code', company_setup)) {
        delete temp[this.getJEName('dept_code', company_setup)];
      }
      if(!this.IsJeVisible('geo_code', company_setup)) {
        delete temp[this.getJEName('geo_code', company_setup)];
      }
      if(!this.IsJeVisible('entity_code', company_setup)) {
        delete temp[this.getJEName('entity_code', company_setup)];
      }
      if(!this.IsJeVisible('delivery_center_code', company_setup)) {
        delete temp[this.getJEName('delivery_center_code', company_setup)];
      }
      if(!this.IsJeVisible('employee_code', company_setup)) {
        delete temp[this.getJEName('employee_code', company_setup)];
      }
      if(!this.IsJeVisible('horizontal_code', company_setup)) {
        delete temp[this.getJEName('horizontal_code', company_setup)];
      }
      if(!this.IsJeVisible('intercompany_code', company_setup)) {
        delete temp[this.getJEName('intercompany_code', company_setup)];
      }
      if(!this.IsJeVisible('lob_code', company_setup)) {
        delete temp[this.getJEName('lob_code', company_setup)];
      }
      if(!this.IsJeVisible('spare2_code', company_setup)) {
        delete temp[this.getJEName('spare2_code', company_setup)];
      }
      data.push(temp);
    }
    this.excelService.export(data, "Export JE Data");
  }

  IsJeVisible(key, company_setup)
  { 
    return  company_setup.invoiceJESettings.length>0?(company_setup.invoiceJESettings.some((v)=>{return v.key==key && v.is_visible})):false;
  }
  getJEName(key, company_setup)
  { 
    return  company_setup.invoiceJESettings.length>0?(company_setup.invoiceJESettings.some((v)=>{return v.key==key})?company_setup.invoiceJESettings.filter((v)=>{return v.key==key})[0].custom_name:''):''
  }

  /**
   * Checks if invoice can be edited before approval
   * @param invoiceId - The invoice ID(s) to check - can be string or array of strings
   * @param is_back
   * @returns Observable<boolean> - true if invoice can be edited, false otherwise
   */
  checkInvoiceIsEdited(invoiceId: string | string[], is_back: string,is_edit = false): Observable<boolean> {
    // Handle both string and array types for invoice_id
    let processedInvoiceId: any;
    if (Array.isArray(invoiceId)) {
      // If it's an array, join the invoice IDs with comma separator
      processedInvoiceId = invoiceId.length > 0 ? invoiceId : '0';
    } else {
      // If it's a string, use it directly
      processedInvoiceId = invoiceId ? invoiceId : '0';
    }

    // If is_edit is present and true, use true, otherwise default to false
    const isEditValue = is_edit === true;

    let send_payload: any = {
      company_id: this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '0',
      user_id: this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0',
      invoice_id: processedInvoiceId,
      is_back: is_back ? is_back : '0',
      view_summary : isEditValue ?'0':'1'
    };
    if(isEditValue){
      send_payload.open_page_time = localStorage.getItem("approver_view_time") || '';
    }
    return this.commonPostMethod('Invoices/view_invoice_process', send_payload)
      .map((data: any) => {
        if(data.status){
          return data.status === true;
        } else {
          this.toasterService.pop('error', 'Error', data.message);
          return false;
        }
      })
      .catch((error: any) => {
        return Observable.of(false);
      });
  }

  normalizeInvoiceNo(value: any): string {
    if (value === null || value === undefined) return '';
    var invoiceNo = String(value)
      .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '')
      .normalize('NFKC')
      .replace(/\u00A0/g, ' ')
      .trim();

    // Convert common OCR confusable characters to ASCII to avoid encoding issues in downstream systems.
    var confusableMap: any = {
      '\u0391': 'A', // Greek Alpha
      '\u0392': 'B', // Greek Beta
      '\u0395': 'E', // Greek Epsilon
      '\u0396': 'Z', // Greek Zeta
      '\u0397': 'H', // Greek Eta
      '\u0399': 'I', // Greek Iota
      '\u039A': 'K', // Greek Kappa
      '\u039C': 'M', // Greek Mu
      '\u039D': 'N', // Greek Nu
      '\u039F': 'O', // Greek Omicron
      '\u03A1': 'P', // Greek Rho
      '\u03A4': 'T', // Greek Tau
      '\u03A5': 'Y', // Greek Upsilon
      '\u03A7': 'X', // Greek Chi
      '\u03BF': 'O', // Greek omicron
      '\u03C1': 'P', // Greek rho
      '\u0406': 'I', // Cyrillic Byelorussian-Ukrainian I
      '\u0410': 'A', // Cyrillic A
      '\u0412': 'B', // Cyrillic Ve
      '\u0415': 'E', // Cyrillic Ie
      '\u041A': 'K', // Cyrillic Ka
      '\u041C': 'M', // Cyrillic Em
      '\u041D': 'H', // Cyrillic En (H-like)
      '\u041E': 'O', // Cyrillic O
      '\u0420': 'P', // Cyrillic Er
      '\u0421': 'C', // Cyrillic Es
      '\u0422': 'T', // Cyrillic Te
      '\u0425': 'X'  // Cyrillic Ha
    };

    invoiceNo = invoiceNo
      .split('')
      .map((ch: string) => confusableMap[ch] || ch)
      .join('');

    // Keep printable invoice-safe characters; replace other symbols with space and collapse.
    return invoiceNo
      .replace(/[^0-9A-Za-z\/._\- ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  areConfusableGstinChars(a: string, b: string): boolean {
    if (!a || !b) return false;
    var ca = a.toUpperCase();
    var cb = b.toUpperCase();
    if (ca === cb) return true;
    var pairs: any = {
      '0': ['O'],
      'O': ['0'],
      '1': ['I', 'L'],
      'I': ['1', 'L'],
      'L': ['1', 'I'],
      '2': ['Z'],
      'Z': ['2'],
      '5': ['S'],
      'S': ['5'],
      '8': ['B'],
      'B': ['8'],
      '7': ['T'],
      'T': ['7']
    };
    var list = pairs[ca];
    return !!(list && list.indexOf(cb) !== -1);
  }

  getGstinSimilarityScore(ocrGstin: string, dbGstin: string): number {
    if (!ocrGstin || !dbGstin) return Number.MAX_SAFE_INTEGER;
    var a = ocrGstin.toUpperCase().replace(/\s+/g, '');
    var b = dbGstin.toUpperCase().replace(/\s+/g, '');

    if (Math.abs(a.length - b.length) > 1) {
      return Number.MAX_SAFE_INTEGER;
    }

    var len = Math.min(a.length, b.length);
    var score = 0;

    for (var i = 0; i < len; i++) {
      var ca = a[i];
      var cb = b[i];
      if (ca === cb) {
        continue;
      }

      if (this.areConfusableGstinChars(ca, cb)) {
        score += 1;
      } else {
        score += 3;
      }

      var isDigitA = /\d/.test(ca);
      var isDigitB = /\d/.test(cb);
      if (isDigitA !== isDigitB) {
        score += 1;
      }
    }

    score += Math.abs(a.length - b.length) * 2;
    return score;
  }

  getBestMatchingCompanyGstin(ocrGstin: string, candidates: string[]): string {
    if (!ocrGstin || !candidates || !candidates.length) return null;

    var bestScore = Number.MAX_SAFE_INTEGER;
    var bestValue: string = null;

    for (var i = 0; i < candidates.length; i++) {
      var gst = candidates[i];
      if (!gst) continue;
      var score = this.getGstinSimilarityScore(ocrGstin, gst);
      if (score < bestScore) {
        bestScore = score;
        bestValue = gst;
      }
    }

    if (bestScore === 0) return bestValue;
    if (bestScore <= 4 && bestValue && bestValue.replace(/\s+/g, '').length === 15) {
      return bestValue;
    }
    return null;
  }
  styleDisplay(prop:string,id:string){
    // id:'full_name',prop:'none/block'
    const element = document.getElementById(id);
    if (element) {
      element.style.display = prop;
    }
  }
  getNextApril30() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0 = Jan, 3 = April, 4 = May
  
    let yearForApril30;
    if (currentMonth === 3) {
      // It's April, so return this year's April 30
      yearForApril30 = currentYear;
    } else if (currentMonth > 3) {
      // After April, so return next year's April 30
      yearForApril30 = currentYear + 1;
    } else {
      // Before April, return this year's April 30
      yearForApril30 = currentYear;
    }
  
    return new Date(yearForApril30, 3, 30);
  }

  getFieldValue(record: any, fieldName: string): string {
    if (record && record.field_data && record.field_data[fieldName] && record.field_data[fieldName].value) {
      return record.field_data[fieldName].value;
    }
    return '';
  }

  extractTableData(invoiceRecord: any[]): any[] {
    if (!invoiceRecord || invoiceRecord.length === 0) {
      return [];
    }
    
    const firstRecord = invoiceRecord[0];
    if (firstRecord && firstRecord.table_data && firstRecord.table_data.length > 0) {
      // table_data is an array of arrays, where each inner array contains line items
      const lineItems = firstRecord.table_data[0]; // Get the first (and usually only) array of line items
      
      if (Array.isArray(lineItems)) {
        return lineItems.map(item => ({
          item_description: this.getFieldValueFromItem(item, 'item_description'),
          item_hsn: this.getFieldValueFromItem(item, 'item_hsn'),
          item_uom: this.getFieldValueFromItem(item, 'item_uom'),
          item_unit_price: this.getFieldValueFromItem(item, 'item_unit_price'),
          item_quantity: this.getFieldValueFromItem(item, 'item_quantity'),
          item_taxable_value: this.getFieldValueFromItem(item, 'item_taxable_value'),
          predicted_product_code: this.getFieldValueFromItem(item, 'predicted_product_code'),
          predicted_product_id: this.getFieldValueFromItem(item, 'predicted_product_id'),
          predicted_product_name: this.getFieldValueFromItem(item, 'predicted_product_name'),
          item_cgst: this.getFieldValueFromItem(item, 'item_cgst'),
          item_sgst: this.getFieldValueFromItem(item, 'item_sgst'),
          item_igst: this.getFieldValueFromItem(item, 'item_igst'),
          item_ugst: this.getFieldValueFromItem(item, 'item_ugst'),
          item_cess: this.getFieldValueFromItem(item, 'item_cess'),
          item_other_tax: this.getFieldValueFromItem(item, 'item_other_tax'),
          item_cgst_amount: this.getFieldValueFromItem(item, 'item_cgst_amount'),
          item_sgst_amount: this.getFieldValueFromItem(item, 'item_sgst_amount'),
          item_igst_amount: this.getFieldValueFromItem(item, 'item_igst_amount'),
          item_ugst_amount: this.getFieldValueFromItem(item, 'item_ugst_amount'),
          item_cess_amount: this.getFieldValueFromItem(item, 'item_cess_amount'),
          item_other_tax_amount: this.getFieldValueFromItem(item, 'item_other_tax_amount'),
        }));
      }
    }
    
    return [];
  }

  private getFieldValueFromItem(item: any, fieldName: string): any {
    if (item && item[fieldName] && item[fieldName].value !== undefined && item[fieldName].value !== null) {
      return item[fieldName].value;
    }
    return '';
  }

  convertMultipleUOMPrice(price: number, currentUnitId: any, requiredUnitId: any, unitTypeList: any[], limit?: number): number {
    const unitTypeListRaw = unitTypeList || [];
    const tdata = unitTypeListRaw.filter((v: any) => String(v.unit_id) == String(currentUnitId));
    const tdataRequired = unitTypeListRaw.filter((v: any) => String(v.unit_id) == String(requiredUnitId));
    if (tdata.length === 0) {
      return this.convertNaN(price, limit);
    }
    if (tdataRequired.length === 0) {
      return this.convertNaN(price, limit);
    }
    const currentConv = tdata[0].conversion_rate ? Number(tdata[0].conversion_rate) : 0;
    const requiredConv = tdataRequired[0].conversion_rate ? Number(tdataRequired[0].conversion_rate) : 0;
    if (currentConv > 0 && requiredConv > 0) {
      return this.convertNaN(parseFloat(this.convertNaN(price,limit)) * currentConv / requiredConv, limit);
    }
    return this.convertNaN(price, limit);
  }
  /**
   * Maps company setup variables for SRN page
   * If isSrnPage is true, maps srn_ prefixed variables to their IRN equivalents
   * If isSrnPage is false, returns original company_setup
   * @param company_setup - Original company setup object from backend
   * @param isSrnPage - Boolean flag indicating if it's SRN page
   * @returns Mapped company setup object
   */
  getCompanySetupForPage(company_setup: any, isSrnPage: boolean): any {
    // If company_setup is null/undefined, return empty object
    if (!company_setup || typeof company_setup !== 'object') {
      return company_setup || {};
    }

    // If not SRN page, return original company_setup (create a copy to avoid reference issues)
    if (!isSrnPage) {
      return JSON.parse(JSON.stringify(company_setup));
    }

    // For SRN page, create mapped object
    const mappedSetup: any = {};
    
    // First, copy all original properties
    for (let key in company_setup) {
      if (company_setup.hasOwnProperty(key)) {
        mappedSetup[key] = company_setup[key];
      }
    }

    // Then, override with SRN values where they exist
    for (let key in company_setup) {
      if (company_setup.hasOwnProperty(key)) {
        // If key starts with 'srn_', extract IRN variable name and map it
        if (key.startsWith('srn_')) {
          const irnKey = key.substring(4); // Remove 'srn_' prefix
          // Map srn_ variable value to IRN variable name
          mappedSetup[irnKey] = company_setup[key];
        } else {
          // For non-srn_ keys, check if corresponding srn_ version exists
          const srnKey = 'srn_' + key;
          if (company_setup.hasOwnProperty(srnKey)) {
            // Use SRN value if it exists
            mappedSetup[key] = company_setup[srnKey];
          }
          // Otherwise, keep original value (already copied above)
        }
      }
    }

    return mappedSetup;
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src3003919298/src/src/app/shared/services/web-service.service.ts